import React, { useState } from 'react';
import Card from 'components/v2/card/Card';
import CardFooter from 'components/v2/card/CardFooter';
import CardHeader from 'components/v2/card/CardHeader';
import { useTranslation } from 'react-i18next';
import { useCreateQuickPay } from 'hooks/quick-pay/useContracts';
import { showToast } from 'stores/ToastStore';
import moment from 'moment-timezone';
import ContractForm from './ContractForm';

export default function AddContractForm({ carrier, onCancel, activeTermsAndConditions = [] }) {
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);

  const onSaveSuccess = (response) => {
    if (response?.validation_errors?.length) {
      const { validation_errors: errors } = response;
      let errorMessages = '';
      if (errors.length === 1) {
        errorMessages = errors[0]?.message;
      } else {
        errorMessages = errors.reduce(
          (acc, { message }, idx) => acc + `${idx + 1}. ${message} \n`,
          '',
        );
      }

      showToast(errorMessages, errorMessages, 'error');
      setSaving(false);
    } else if (response?.contract) {
      showToast(
        t('CREATE_QUICKPAY_SUCCESS'),
        t('CREATE_QUICKPAY_SUCCESS'),
        'success',
      );
      setSaving(false);
      onCancel();
    }
  };

  const onSaveFail = (error) => {
    setSaving(false);
    const response = error?.entity;
    if (!response?.success && response?.validation_errors?.length) {
      const { validation_errors: errors } = response;
      let errorMessages = '';
      if (errors.length === 1) {
        errorMessages = errors[0]?.message;
      } else {
        errorMessages = errors.reduce(
          (acc, { message }, idx) => acc + `${idx + 1}. ${message} \n`,
          '',
        );
      }
      showToast(errorMessages, errorMessages, 'error');
    }
  };

  const { mutation } = useCreateQuickPay(onSaveSuccess, onSaveFail);

  function renderHeader() {
    return <CardHeader title={t('ADD_CONTRACT')} />;
  }
  function renderFooter() {
    return (
      <CardFooter
        onActionClick={() => {
          setSaving(true);
        }}
        onCancelClick={onCancel}
        actionTestDataId="quickpay-add-save"
        cancelTestDataId="quickpay-add-cancel"
      />
    );
  }

  const handleSave = async (newContract) => {
    const start_date = moment(newContract.start_date).format('YYYY-MM-DD');
    const end_date = moment(newContract.end_date).format('YYYY-MM-DD');
    newContract.end_date = end_date;
    newContract.start_date = start_date;
    const payload = { user: carrier, ...newContract };
    setSaving(true);
    await mutation.mutateAsync(payload);
  };
  const onValidSuccess = (data) => {
    handleSave(data);
  };

  const onValidFail = () => {
    setSaving(false);
  };

  return (
    <Card header={renderHeader} footer={renderFooter}>
      <ContractForm
        data={{}}
        saving={saving}
        onValidSuccess={onValidSuccess}
        onValidFail={onValidFail}
        activeTermsAndConditions={activeTermsAndConditions}
      />
    </Card>
  );
}
